// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pricing-table-icon[data-v-8987286c]{font-size:.75rem}.pricing-table-icon__title[data-v-8987286c]{display:block;font-size:.85rem;margin-bottom:.25rem}.icon-circle.icon-circle[data-v-8987286c]{background-color:#fff;border:1px solid var(--g-color-gray-200);color:var(--g-color-primary)}.icon-circle.icon-circle--dull[data-v-8987286c]{color:var(--g-color-gray-400)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
